'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getCurrentChannel = exports.getCurrentChannel = function getCurrentChannel(state) {
  return state.currentChannel;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/conversationSelectors/getCurrentChannel.js
// module id = 46
// module chunks = 2 3